export default __webpack_public_path__ + "static/house1-7a4217d348d56a00eb2e3a4cae41bfa7.png";